import React, { CSSProperties } from 'react';

import { cn } from '@column/ui';

export interface ApiKeyPreviewProps {
  className?: string;
  prefix?: string;
  value?: string;
  placeholder?: string;
  style?: CSSProperties;
}

const DOTS = '•'.repeat(4);

export const ApiKeyPreview: React.FC<ApiKeyPreviewProps> = (props) => (
  <div
    style={props.style}
    className={cn(
      'flex w-full items-center gap-px overflow-hidden text-xs leading-6 font-medium whitespace-nowrap',
      props.value ? 'text-gray-600 dark:text-gray-200' : 'text-muted-foreground',
      props.className
    )}
  >
    {props.value ? (
      <>
        {props.prefix && <span className="flex-none font-mono">{props.prefix}</span>}
        <span aria-hidden className="min-w-0 flex-[0_1_auto] overflow-hidden text-[9px] tracking-[1px]">
          {DOTS}
        </span>
        <span className="flex-none font-mono">{props.value}</span>
      </>
    ) : (
      props.placeholder
    )}
  </div>
);
